export enum EInputFieldType {
    Text = 'text',
    Email = 'email',
    Number = 'number',
    Date = 'date',
    Select = 'select',
    Phone = 'phone',
}
